import React from 'react';

const PasswordForgetPage = () =>
  <div>
    <h1>PasswordForget Page</h1>
  </div>

export default PasswordForgetPage;